import { Injectable } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';
import { FsTransferService } from '@firestitch/transfer';

import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class DocData {

  constructor(
    private _api: FsApi,
    private _transfer: FsTransferService,
  ) { }

  public create(data = { id: null }) {
    return data;
  }

  public get(docId: number | string, query = {}): Observable<any> {
    return this._api.get(`docs/${docId}`, query, { key: 'doc' });
  }

  public gets(data = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.request('GET', 'docs', data, { key: 'docs', ...config });
  }

  public put(doc, config: RequestConfig = {}): Observable<any> {
    return this._api.put(`docs/${doc.id}`, doc, { key: 'doc', ...config });
  }

  public post(doc, config = { key: 'doc' }): Observable<any> {
    return this._api.post('docs', doc, { key: 'doc' });
  }

  public delete(doc): Observable<any> {
    return this._api.delete(`docs/${doc.id}`, doc, { key: 'doc' });
  }

  public bulk(docIds: number[], data: any): Observable<any> {
    return this._api.put('docs/bulk', { docIds, ...data }, { key: 'docs' });
  }

  public bulkDelete(docIds: number[]): Observable<any> {
    return this._api.delete('docs/bulk', { docIds }, { key: 'docs' });
  }

  public saveNewVersion(docId: number, data: any): Observable<any> {
    return this._api.post(`docs/${docId}/content`, data, { key: 'doc' });
  }

  public save(data, config = { key: 'doc' }): Observable<any> {
    if (data.id) {
      return this.put(data, config);
    }

    return this.post(data, config);
  }

  public getParsedName(data): Observable<any> {
    return this._api.get('docs/name', data, { key: 'name' });
  }

  public export(data): void {
    this._transfer.post(`docs/${data.id}/export`);
  }

}
